import {
	CloudIcon as ManageIconOutline,
	ClipboardDocumentListIcon as MatchesIconOutline,
	UserGroupIcon as TeamsIconOutline,
} from "@heroicons/react/24/outline";
import {
	CloudIcon as ManageIconSolid,
	ClipboardDocumentListIcon as MatchesIconSolid,
	UserGroupIcon as TeamsIconSolid,
} from "@heroicons/react/24/solid";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Tabs } from "~components/Tabs";
import { useCurrentEvent } from "~hooks/state";
import { useAddEventVisited } from "~utils/hooks/history";
import { EventManageTab } from "./-tabs/manage";
import { EventMatchesTab } from "./-tabs/matches";
import { EventTeamsTab } from "./-tabs/teams";

export const EventHome: React.FC = () => {
	const { data: event } = useCurrentEvent();
	const { mutateAsync: addEvent, isSuccess } = useAddEventVisited();

	useEffect(() => {
		if (event && !isSuccess) {
			addEvent(event);
		}
	}, [event, isSuccess, addEvent]);

	return event ? (
		<section className="mt-4 flex flex-col">
			<Tabs
				id={["/$sku/$division", "EventHome"]}
				className="flex-1"
				parts={{
					tablist: {
						className: "absolute bottom-0 right-0 left-0 z-10 p-0 bg-zinc-900",
					},
				}}
			>
				{[
					{
						type: "content",
						id: "matches",
						label: "Matches",
						icon: (active) =>
							active ? (
								<MatchesIconSolid height={24} className="inline" />
							) : (
								<MatchesIconOutline height={24} className="inline" />
							),
						content: <EventMatchesTab event={event} />,
					},
					{
						type: "content",
						id: "team",
						label: "Teams",
						icon: (active) =>
							active ? (
								<TeamsIconSolid height={24} className="inline" />
							) : (
								<TeamsIconOutline height={24} className="inline" />
							),
						content: <EventTeamsTab event={event} />,
					},
					{
						type: "content",
						id: "manage",
						label: "Manage",
						icon: (active) =>
							active ? (
								<ManageIconSolid height={24} className="inline" />
							) : (
								<ManageIconOutline height={24} className="inline" />
							),
						content: <EventManageTab event={event} />,
					},
				]}
			</Tabs>
		</section>
	) : null;
};

export const Route = createFileRoute("/$sku/$division/")({
	component: EventHome,
});
